export default __webpack_public_path__ + "static/media/argon-react.dc90e648.png";